/**
 * [TD-47.3] DraftQueueContext - single-instance provider for the snake
 * draft queue. Mounts `useDraftQueue` once inside SnakeDraftRoomInner and
 * fans the queue state out to consumers (SnakePlayerPool / QueueButton /
 * SnakeCenterSurface / DraftQueue tab).
 *
 * Snake-only by design (TD-57 closed; auction has no queue). DraftRoom
 * (auction) does NOT mount this provider; consumers gate on a null context
 * default.
 */
import { createContext, useContext } from "react";
import { useDraftQueue } from "../hooks/useDraftQueue";

const DEFAULT = {
  queue: [],
  addToQueue: () => {},
  removeFromQueue: () => {},
  reorderQueue: () => {},
  moveUp: () => {},
  moveDown: () => {},
  clearQueue: () => {},
  isQueued: () => false,
  topOfQueue: null,
  queueCapped: false,
};

const DraftQueueContext = createContext(DEFAULT);

export function DraftQueueProvider({ leagueId, userId, children }) {
  const value = useDraftQueue(leagueId, userId);
  return (
    <DraftQueueContext.Provider value={value}>
      {children}
    </DraftQueueContext.Provider>
  );
}

export const useDraftQueueContext = () => useContext(DraftQueueContext);

// Test-only escape hatch
export const __DEFAULT_DRAFT_QUEUE__ = DEFAULT;
